import { render, staticRenderFns } from "./floatingBtnGold.vue?vue&type=template&id=54fa17d9&scoped=true"
import script from "./floatingBtnGold.vue?vue&type=script&lang=js"
export * from "./floatingBtnGold.vue?vue&type=script&lang=js"
import style0 from "./floatingBtnGold.vue?vue&type=style&index=0&id=54fa17d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa17d9",
  null
  
)

export default component.exports